import { InferSelectModel } from 'drizzle-orm';
import {
	index,
	pgTable,
	serial,
	timestamp,
	varchar,
} from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';

/**
 * This table stores V3 gate keeping codes.
 * Each code can be used by multiple users to gain access to the app.
 * For bypass key usage, code will be null.
 */
export const v3_gate_keeping_codes = pgTable(
	'v3_gate_keeping_codes',
	{
		id: serial('id').primaryKey(),

		code: varchar('code', { length: 50 }),

		usedByAuthorities: varchar('usedByAuthorities', { length: 44 })
			.array()
			.notNull()
			.default(sql`ARRAY[]::varchar[]`),

		createdAt: timestamp('createdAt', { withTimezone: true })
			.notNull()
			.defaultNow(),
	},
	(t) => {
		return {
			codeUniqueIdx: index('codeUniqueIdx')
				.on(t.code)
				.where(sql`${t.code} IS NOT NULL`),
			usedByAuthoritiesIdx: index('usedByAuthoritiesIdx').on(
				t.usedByAuthorities
			),
		};
	}
);

export type V3GateKeepingCode = InferSelectModel<typeof v3_gate_keeping_codes>;
